<template>
  <div
    class="fts-toggle-tokens"
    :class="[
      {'toggle-tokens--disabled': disabled},
      {'comfort-design': comfortDesign}
    ]"
  >
    <div class="toggle-tokens-container" v-if="options && options.length">
      <div
        v-for="option in options"
        :key="option.id"
        class="toggle-tokens-wrapper"
        :class="{'toggle-tokens-wrapper--active': isSelected(option)}"
        @click="select(option)"
      >
        <slot
          name="optionLabel"
          :option="option"
          :optionLabel="getLabel(option)"
        >
          {{getLabel(option)}}
        </slot>
      </div>    
    </div>
    <div class="toggle-tokens-no-found" v-else>
      No options found.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Object, Array],
    options: Array,
    label: {
      type: String,
      default: "name",
    },
    reduceKey: String,
    reduce: Function,
    multiple: Boolean,
    comfortDesign: Boolean,
    disabled: Boolean,
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  methods: {
    isObject(option) {
      return Object.prototype.toString.call(option) === '[object Object]';
    },
    isSelected(option) {
      let value = this.getValue(option);
      if (this.multiple) {
        return Array.isArray(this.value) && this.value.some(x => x === value);
      } else {
        return this.value === value;
      }
    },
    getLabel(option) {
      if (this.isObject(option)) {
        if (option[this.label] === undefined || option[this.label] === null) {
          return "undefined";
        }
        return option[this.label];
      }
      return option;
    },
    getValue(option) {
      if (this.isObject(option)) {
        if (this.reduceKey) {
          return option[this.reduceKey];
        } else if (Object.prototype.toString.call(this.reduce) === '[object Function]') {
          try {
            return this.reduce(option);
          } catch(err) {
            console.warn('[FTSToggleTokens] reduce function error', err);
          }
        } else {
          return option.value;
        }
      }
      return option;
    },
    select(option) {
      if (this.disabled) return;

      let value = this.getValue(option);
      if (this.multiple) {
        if (Array.isArray(this.value)) {
          let values = [...this.value];  

          const findIndex = values.findIndex(x => x === value);
          if (findIndex > -1) {
            this.$emit("deselected", value);
            values.splice(findIndex, 1);
          } else {
            this.$emit("selected", value);
            values.push(value);   
          }

          this.$emit("updateValue", values);
        } else {
          this.$emit("selected", value);
          this.$emit("updateValue", [value]);
        }
      } else {
        this.$emit("selected", value);
        this.$emit('updateValue', value);   
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-toggle-tokens {
  &.toggle-tokens--disabled {
    .toggle-tokens-wrapper {
      cursor: not-allowed;
    }
  }
  &:not(.toggle-tokens--disabled) {
    .toggle-tokens-wrapper {
      cursor: pointer;
    }
  }
  &.comfort-design {
    .toggle-tokens-container {
      .toggle-tokens-wrapper {
        border-radius: $comfort-border-radius;
        font-size: $comfort-font-size;
      }
    }
    .toggle-tokens-no-found {
      font-size: $comfort-font-size;
    }
  }
  .toggle-tokens-container {
    @include flex-gap($display: flex, $gap: 0.575rem);
    .toggle-tokens-wrapper {
      @include user-select-none;
      padding: .375rem .75rem;
      background-color: var(--fts-gray-100);
      font-size: .75rem;
      color: var(--fts-form-label);
      transition: background .3s ease-in-out;
      &.toggle-tokens-wrapper--active {
        background-color: var(--fts-primary);
        color: #fff;
      }
    }
  }
  .toggle-tokens-no-found {
    padding-top: .375rem;
    padding-bottom: .375rem;
    font-size: .75rem;
    color: var(--fts-gray-400);
  }
}
</style>